export function topics(state = [], action) {
  const { detail } = action;
  switch (action.type) {
    case 'LOAD_TOPICS':
      return detail;
    default:
      return state;
  }
}
